import React, { useEffect, useState } from 'react'
import { Modal, Button, Table, Form } from 'react-bootstrap'
import { format } from 'date-fns'
import { toast } from 'react-toastify'
import apinode from '../../services/apinode'
import { CustomButton } from '../../components/CustomButton'

const ModalTable = ({ data, showModal, handleClose }) => {
  const [devolv, setDevolv] = useState([])
  const [isDevolvLoading, setIsDevolvLoading] = useState({})

  useEffect(() => {
    setDevolv(data)
  }, [data])

  const handleEstorno = async (id_pedido, qtd, sku, index) => {
    try {
      setIsDevolvLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.put(
        `/devolucoes/dev/parcial/${localStorage.idconta}`,
        {
          qtd: qtd,
          sku: sku,
          pedido: id_pedido,
        },
      )

      toast.success(response.data.message)
      await load(id_pedido)
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      toast.error(`Erro ao solicitar estorno. Resposta: ${error.message}`)
      // setPedido('');
    } finally {
      setIsDevolvLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const load = async (id_pedido) => {
    try {
      const response = await apinode.get(
        `/devolucoes/listar/${id_pedido}/${localStorage.idconta}`,
      )

      const formatted = response.data.map((item) => ({
        ...item,
        vai_devolver: 0,
      }))

      setDevolv(formatted)
    } catch {
      toast.error('Erro ao realizar solicitação.')
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>Lista de Itens</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          striped
          bordered
          hover
        >
          <thead>
            <tr>
              <th>Código</th>
              <th>SKU</th>
              <th>Pedido</th>
              <th>Data</th>
              <th>Hora</th>
              <th>Qtd</th>
              <th>Qtd devolvida</th>
              <th>Vai Devolver</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {devolv.map((item, index) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.sku}</td>
                <td>{item.id_pedido}</td>
                <td>
                  {format(new Date(item.data_conf), 'dd/MM/yyyy HH:mm:ss')}
                </td>
                <td>{format(new Date(item.hora_conf), 'HH:mm:ss')}</td>
                <td>{item.qtde}</td>
                <td>{item.qtde_devolvida ?? 0}</td>
                <td>
                  <Form.Control
                    type="number"
                    value={item.vai_devolver}
                    min={1}
                    style={{
                      width: 100,
                    }}
                    onChange={(e) =>
                      setDevolv((prevState) =>
                        prevState.with(index, {
                          ...prevState[index],
                          vai_devolver: e.target.value,
                        }),
                      )
                    }
                  />
                </td>
                <td>
                  <CustomButton
                    variant="outline-danger"
                    size="sm"
                    onClick={() =>
                      handleEstorno(
                        item.id_pedido,
                        item.vai_devolver,
                        item.sku,
                        index,
                      )
                    }
                    isLoading={isDevolvLoading[index]}
                    isLoadingText="Devolvendo..."
                    isDelete
                    isDisabled={devolv.some(
                      (item) =>
                        item.vai_devolver &&
                        Number(item.vai_devolver) > Number(item.qtde),
                    )}
                  >
                    Estornar
                  </CustomButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalTable
